import React from 'react';
import { Switch } from 'antd';
import { useDispatch } from 'react-redux';
import { setEditMode } from 'store/reducers/SettingsSlice';
import { useAppSelector } from 'hooks/redux';

const EditModeToggle: React.FC = () => {
  const dispatch = useDispatch();
  const isEditMode = useAppSelector((state) => state.settings.editMode);

  return (
    <div style={{ padding: "0 2px" }}>
      <p style={{ fontSize: "8px", margin: 0 }}>edit mode</p>
      <Switch
        checked={isEditMode}
        onChange={(checked) => dispatch(setEditMode(checked))}
        style={{
          backgroundColor: isEditMode ? "rgb(124, 190, 123)" : undefined,
          minWidth: "34px",
          outline: isEditMode ? undefined : "rgb(124, 190, 123) 1px solid",
        }}
      />
    </div>
  );
};

export default EditModeToggle;